module.exports = __webpack_public_path__ + "static/img/head_bg.570429e8.png";